<!-- Custom Automation Modal -->

<form [formGroup]="createAutomationForm" aria-label="custom-automation-popup-form" data-testid="custom-automation-popup-form">
<!-- Content -->
<div class="px-3 pt-4 pb-3 surface-0">
  <h3 class="text-base md:text-lg font-normal" data-testid="custom-automation-popup-header">{{'AUTOMATION.CREATE.NAME_DESCR' | translate}}</h3>
  <input type="text" class="w-full text-sm mb-2" formControlName="automation_name" pInputText [placeholder]="'AUTOMATION.CREATE.PLACE_NAME' | translate" aria-label="custom-automation-popup-name-input" data-testid="custom-automation-popup-name-input" />
  <div *ngIf="AutomationNameFormControl.touched && AutomationNameFormControl.invalid" class="mb-2 -mt-2">
  <app-error-msg [errors]="AutomationNameFormControl.errors" [fieldLabel]=" 'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate" data-testid="custom-automation-popup-name-error"> </app-error-msg>
</div>
  <textarea pTextarea class="w-full h-4rem text-sm" formControlName="automation_description" [placeholder]="'AUTOMATION.CREATE.PLACE_DESC' | translate" aria-label="custom-automation-popup-description-input" data-testid="custom-automation-popup-description-input"></textarea>
  <app-error-msg *ngIf="AutomationDescriptionFormControl.touched && AutomationDescriptionFormControl.invalid" [errors]="AutomationDescriptionFormControl.errors" [fieldLabel]=" 'SEND_EMAIL.CAMPAIGN_DESCRIPTION_ERROR' | translate" data-testid="custom-automation-popup-description-error">
  </app-error-msg>
</div>
<!-- Content -->

<!-- Content -->
<div class="surface-0 p-3 pb-8">
  <h3 class="text-base md:text-lg font-normal mb-0" data-testid="custom-automation-popup-ownership-label">{{ 'AUTOMATION.CREATE.WHO_FOR_AUTO' | translate }}</h3>

  <!-- Current Tenant -->
  <div class="surface-0 border-round shadow-1 p-3 border-2 mt-3" [ngClass]="OwnershipFormControl.value === ownershipLevel.Tenant ? 'border-primary' : 'border-300' ">
      <div class="flex align-items-center justify-content-between">
          <div>
              <h6 class="mb-0 text-base" [ngClass]="OwnershipFormControl.value === ownershipLevel.Tenant ? 'text-primary' : 'text-600' "> {{ 'AUTOMATION.CREATE.CURRENT_TENANT' | translate }}  : {{ logginTenant.name_primary_language || logginTenant.name_secondary_language}}</h6>
              <p class="mb-0 text-xs">{{ 'AUTOMATION.CREATE.FOR_TENANT' | translate }}</p>
          </div>
          <div>
              <button
                  [ngClass]="OwnershipFormControl.value === ownershipLevel.Tenant || OwnershipFormControl.value.toString() === ownershipLevel[ownershipLevel.Tenant] ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary'"
                  (click)="SelectOwnership(ownershipLevel.Tenant)"
                  class="p-ripple p-element text-sm p-button p-component py-1 line-height-3 hidden md:block"
                  [disabled]="modelData.event === 'update'"
                  aria-label="custom-automation-popup-tenant-ownership-button" data-testid="custom-automation-popup-tenant-ownership-button"
              >
                  <span class="fa fa-check-circle p-button-icon p-button-icon-left"></span>
                  <span *ngIf="OwnershipFormControl.value !== ownershipLevel.Tenant" class="p-button-label">{{ 'AUTOMATION.CREATE.BTN_SELECT' | translate }}</span>
                  <span *ngIf="OwnershipFormControl.value === ownershipLevel.Tenant" class="p-button-label">{{ 'AUTOMATION.CREATE.BTN_SELECT_CONFIGURE' | translate }}</span>
              </button>
              <button
                  [ngClass]="OwnershipFormControl.value === ownershipLevel.Tenant ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary'"
                  (click)="SelectOwnership(ownershipLevel.Tenant)"
                  class="p-ripple p-element text-sm p-button p-component p-button-icon-only md:hidden"
                  [disabled]="modelData.event === 'update'"
                  aria-label="custom-automation-popup-tenant-ownership-button-mobile" data-testid="custom-automation-popup-tenant-ownership-button-mobile"
              >
                  <span class="fa fa-check-circle p-button-icon"></span>
              </button>
          </div>
      </div>
  </div>
  <!-- Current Tenant -->

  <!-- Franchise -->
  <div class="surface-0 border-round shadow-1 p-3 border-2 mt-3" [ngClass]="OwnershipFormControl.value === ownershipLevel.Franchise ? 'border-primary' : 'border-300' ">
      <!-- Franchise Header -->
      <div class="flex align-items-center justify-content-between">
          <div>
              <h6 class="mb-0 text-base" [ngClass]="OwnershipFormControl.value === ownershipLevel.Franchise ? 'text-primary' : 'text-600' ">{{'AUTOMATION.CREATE.FRANCHISE' | translate}}</h6>
              <p class="mb-0 text-xs">{{ 'AUTOMATION.CREATE.MULTiPLE_TENENT_FRAN' | translate }}</p>
          </div>
          <div>
              <button
                  [ngClass]="OwnershipFormControl.value === ownershipLevel.Franchise ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary' "
                  (click)="SelectOwnership(ownershipLevel.Franchise)"
                  class="p-ripple p-element text-sm p-button p-component hidden md:block py-1 line-height-3"
                  [disabled]="modelData.event === 'update'"
                  aria-label="custom-automation-popup-franchise-ownership-button" data-testid="custom-automation-popup-franchise-ownership-button"
              >
                  <span class="fa fa-check-circle p-button-icon p-button-icon-left"></span>
                  <span *ngIf="OwnershipFormControl.value !== ownershipLevel.Franchise" class="p-button-label">{{ 'AUTOMATION.CREATE.BTN_SELECT' | translate }}</span>
                  <span *ngIf="OwnershipFormControl.value === ownershipLevel.Franchise" class="p-button-label">{{ 'AUTOMATION.CREATE.BTN_SELECT_CONFIGURE' | translate }}</span>
              </button>
              <button
                  [ngClass]="OwnershipFormControl.value === ownershipLevel.Franchise ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary'"
                  (click)="SelectOwnership(ownershipLevel.Franchise)"
                  class="p-ripple p-element text-sm p-button p-component p-button-icon-only md:hidden"
                  [disabled]="modelData.event === 'update'"
                  aria-label="custom-automation-popup-franchise-ownership-button-mobile" data-testid="custom-automation-popup-franchise-ownership-button-mobile"
              >
                  <span class="fa fa-check-circle p-button-icon"></span>
              </button>
          </div>
      </div>
      <!-- Franchise Header -->

      <!-- Franchise Content -->
      <div *ngIf="OwnershipFormControl.value === ownershipLevel.Franchise" class="border-top-1 border-300 pt-3 mt-3 md:flex">
          <!-- Form Group -->
          <div class="md:w-6 md:pr-3 mb-3 md:mb-0">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="custom-automation-popup-franchise-label">{{ 'AUTOMATION.CREATE.CHOOSE_FRANCHISE' | translate }}</label>
              <p-select [options]="franchiseList" formControlName="selected_frenchise" optionLabel="franchise_group_primary_name" styleClass="text-sm w-full" filterBy="franchise_group_primary_name" [placeholder]="'AUTOMATION.CREATE.PLACE_FRANC' | translate" aria-label="custom-automation-popup-franchise-dropdown" data-testid="custom-automation-popup-franchise-dropdown">
                  <ng-template pTemplate="selectedItem">
                      <div class="text-sm" *ngIf="SelectedFrenchiseFormControl.value">{{SelectedFrenchiseFormControl.value.franchise_group_primary_name}}</div>
                  </ng-template>
                  <ng-template let-franchise pTemplate="item">
                      <div class="text-sm">{{franchise.franchise_group_primary_name}}</div>
                  </ng-template>
              </p-select>
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="md:w-6 pr-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="custom-automation-popup-franchise-tenants-label">{{ 'AUTOMATION.CREATE.SELECT_TENANTS' | translate }}</label>
              <p-multiSelect [options]="franchiseTenants" formControlName="selected_frenchise_tenants" optionLabel="name_primary_language" styleClass="text-sm w-full" filterBy="name_primary_language" [placeholder]="'AUTOMATION.CREATE.SELECT_TENANT' | translate" aria-label="custom-automation-popup-franchise-tenants-dropdown" data-testid="custom-automation-popup-franchise-tenants-dropdown">
                <ng-template let-tenant pTemplate="item">
                    <div class="text-sm">{{tenant.name_primary_language}}</div>
                </ng-template>
            </p-multiSelect>
          </div>
          <!-- Form Group -->
      </div>
      <!-- Franchise Content -->
  </div>
  <!-- Franchise -->

  <!-- Company -->
  <div class="surface-0 border-round shadow-1 p-3 border-2 mt-3" [ngClass]="OwnershipFormControl.value === ownershipLevel.Company ? 'border-primary' : 'border-300' ">
      <!-- Company Header -->
      <div class="flex align-items-center justify-content-between">
          <div>
              <h6 class="mb-0 text-base" [ngClass]="OwnershipFormControl.value === ownershipLevel.Company ? 'text-primary' : 'text-600' ">{{'AUTOMATION.CREATE.COMPANY' | translate}}</h6>
              <p class="mb-0 text-xs">{{ 'AUTOMATION.CREATE.MULTIPLE_TENANTS_COMP' | translate }}</p>
          </div>
          <div>
              <button
                  [ngClass]="OwnershipFormControl.value === ownershipLevel.Company ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary' "
                  (click)="SelectOwnership(ownershipLevel.Company)"
                  class="p-ripple p-element text-sm p-button p-component hidden md:block py-1 line-height-3"
                  [disabled]="modelData.event === 'update'"
                  aria-label="custom-automation-popup-company-ownership-button" data-testid="custom-automation-popup-company-ownership-button"
              >
                  <span class="fa fa-check-circle p-button-icon p-button-icon-left"></span>
                  <span *ngIf="OwnershipFormControl.value !== ownershipLevel.Company" class="p-button-label">{{ 'AUTOMATION.CREATE.BTN_SELECT' | translate }}</span>
                  <span *ngIf="OwnershipFormControl.value === ownershipLevel.Company" class="p-button-label">{{ 'AUTOMATION.CREATE.BTN_SELECT_CONFIGURE' | translate }}</span>
              </button>
              <button [ngClass]="OwnershipFormControl.value === ownershipLevel.Company ? 'p-outline-primary text-primary surface-0' : 'p-button-secondary'" 
               (click)="SelectOwnership(ownershipLevel.Company)" class="p-ripple p-element text-sm p-button p-component p-button-icon-only md:hidden"
               [disabled]="modelData.event === 'update'" aria-label="custom-automation-popup-company-ownership-button-mobile" data-testid="custom-automation-popup-company-ownership-button-mobile">
                  <span class="fa fa-check-circle p-button-icon"></span>
              </button>
          </div>
      </div>
      <!-- Company Header -->

      <!-- Company Content -->
      <div *ngIf="OwnershipFormControl.value === ownershipLevel.Company" class="border-top-1 border-300 pt-3 mt-3 md:flex">
          <!-- Form Group -->
          <div class="md:w-6 pr-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="custom-automation-popup-company-tenants-label">{{ 'AUTOMATION.CREATE.SELECT_TENANTS' | translate }}</label>
              <p-multiSelect [options]="accessedtenants" formControlName="selected_company_tenants"  optionLabel="name_primary_language" styleClass="text-sm w-full" filterBy="name_primary_language"  [placeholder]="'AUTOMATION.CREATE.SELECT_TENANT' | translate" aria-label="custom-automation-popup-company-tenants-dropdown" data-testid="custom-automation-popup-company-tenants-dropdown">
                  <ng-template let-tenant pTemplate="item">
                      <div class="text-sm">{{tenant.name_primary_language}}</div>
                  </ng-template>
              </p-multiSelect>
          </div>
          <!-- Form Group -->
      </div>
      <!-- Company Content -->
  </div>
  <!-- Company -->
</div>
<!-- Content -->

<!-- Modal Footer -->
<div class="surface-0 absolute w-full left-0 bottom-0 z-1 p-3 border-top-1 border-300 flex align-items-center justify-content-between border-round-bottom">
  <p-button (click)="closePopup()" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" aria-label="cancel-custom-automation-popup-button" data-testid="cancel-custom-automation-popup-button"></p-button>
  <p-button  [label]="'AUTOMATION.CREATE.BTN_SAVE_CONTINUE' | translate"
    [disabled]="!createAutomationForm.valid" styleClass="text-sm" [loading]="btnLoading"
    (click)="SaveData()" aria-label="save-continue-custom-automation-popup-button" data-testid="save-continue-custom-automation-popup-button">
  </p-button>
</div>
<!-- Modal Footer -->

</form>
